"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_use_error_boundary_1 = require("react-use-error-boundary");
const game_1 = require("./pages/game");
const lobby_1 = require("./pages/lobby");
const menu_1 = require("./pages/menu");
const plugins_1 = require("./plugins");
const styles_1 = require("./styles");
/**
 * Top-level extension surface for mods that want to render persistent
 * UI without targeting an existing host region.
 */
function AppExtensionSurface() {
    return (React.createElement(plugins_1.Region, { cls: "app-extension", ctx: {} }, null));
}
exports.App = (0, react_use_error_boundary_1.withErrorBoundary)(() => {
    const [error, resetError] = (0, react_use_error_boundary_1.useErrorBoundary)();
    const isInGame = (0, react_redux_1.useSelector)((state) => state.game.ui.inGame);
    const isInLobby = (0, react_redux_1.useSelector)((state) => state.lobby !== null);
    (0, styles_1.useGlobalStyles)();
    if (error) {
        return (React.createElement("div", null,
            React.createElement("p", null, error.message),
            React.createElement("p", null, error.stack),
            React.createElement("button", { onClick: () => window.location.reload() }, "Try again")));
    }
    return (React.createElement(React.Fragment, null,
        isInGame ? React.createElement(game_1.GamePage, null) : isInLobby ? React.createElement(lobby_1.LobbyPage, null) : React.createElement(menu_1.MenuPage, null),
        React.createElement(AppExtensionSurface, null)));
});
